module.exports = __webpack_public_path__ + "assets/images/premium-features/custom-range-ea8fb5.png";